<template>
  <div class="flex items-start p-4 mb-4 text-sm border rounded bg-accent bg-opacity-10 text-accent border-accent">
    <fa :icon="['fas', 'info-circle']" class="mt-px mr-3 text-lg opacity-75" />
    <div>
      {{ content }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'BookHelpBubble',

  props: {
    content: {
      type: String,
      required: true
    }
  }
}
</script>